<template>
  <div class="sidebar-contents">
    <aside class="sidebar-widget">
      <h3>Full Schedule</h3>
      <p>Please <router-link to="/schedule">click here</router-link> to view the full schedule for the Private Wealth Seminars Summer 2020 Livestream</em></p>
    </aside>
    <aside class="sidebar-widget">
      <h3>Having Trouble?</h3>
      <p>Please <router-link to="/faq">review the FAQ for common Questions and Answers</router-link>.</p>
      <p>If you continue to have any issues with the Live Stream event please email here:</p>
      <p><a href="mailto:videoissue@oxfordclub.com">videoissue@oxfordclub.com</a></p>
      <p>Or call us at <a href="tel:888-903-2227">888-903-2227</a> (U.S.) or <a href="tel:1-443-353-4390">+1-443-353-4390</a> (International).</p>
    </aside>
  </div>
</template>

<script>
import helpers from '../helpers';

export default {
  name: 'Sidebar',
  data() { return { year: helpers.getYear(), } },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar-widget {
  border-radius: .25rem;
  background-color: #f9f9f9;
  padding: 1em 1em 0.2em;
  margin-bottom: 10px;
  border: 1px solid #ddd;
}
.sidebar-widget > h3 {
  margin: 0 0 0.6em;
  font-size: 24px;
}
.sidebar-widget > p {
  margin: 0 0 10px;
}
.sidebar-widget > p > a {
  color: #282472;
  font-weight: bold;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue